export default {"src":"/_next/static/media/nextArrow.7c63c4fa.svg","height":56,"width":56};